import LayoutBasic from "@/views/layouts/LayoutBasic";
import runnersOrdersList from "@/views/runners/orders/orders";
import runnersBackpacks from "@/views/runners/backpacks/backpacks";
import runnersBackpacksResets from "@/views/runners/backpacks/history";
import RunnerCurrentReport from "@/views/runners/reports/CurrentReport";
import runnersOrdersToCall from "@/views/runners/runner/ordersToCall";
import runnersOrderTasks from "@/views/runners/orders/orderTasks";
import runnersStorageTasks from "@/views/runners/storage/tasks";
import RunnersInvoices from "@/views/admin/invoices/RunnersInvoices"
import RunnersMap from '@/views/runners/runner/Map.vue';
import RunnersOrdersDelivery from "@/views/runners/orders/Delivery.vue";

const routes = {
  path: '/runners',
  component: LayoutBasic, // Change the desired Layout here,
  meta: {requiresAuth: true},
  children: [
    {
      path: 'orders',
      component: runnersOrdersList,
      name: 'runnersOrdersList',
      meta: {
        permission: 'runners/orders/manage'
      }
    },
    {
      path: 'delivery',
      component: RunnersOrdersDelivery,
      name: 'RunnersOrdersDelivery'
    },
    {
      path: 'backpacks',
      component: runnersBackpacks,
      name: 'runnersBackpacks'
    },
    {
      path: 'backpacksHistory',
      component: runnersBackpacksResets,
      name: 'runnersBackpacksResets'
    },
    {
      path: 'report',
      component: RunnerCurrentReport,
      name: 'RunnerCurrentReport',
      meta: {
        permission: 'runners/report'
      }
    },
    {
      path: '/ordersToCall/remotely',
      component: runnersOrdersToCall,
      meta: {requiresAuth: false},
      name: 'runnersOrdersToCallNoAuth'
    },
    {
      path: 'ordersToCall',
      name: 'runnersOrdersToCall',
      component: runnersOrdersToCall
    },
    {
      path: 'orderTasks',
      name: 'runnersOrderTasks',
      component: runnersOrderTasks
    },
    {
      path: 'storage/Tasks',
      name: 'runnersStorageTasks',
      component: runnersStorageTasks
    },
    {
      path: 'invoices',
      name: 'runnersInvoices',
      component: RunnersInvoices
    },
    {
      path: 'map',
      name: 'runnersMap',
      component: RunnersMap
    },
  ]
}

export default routes
